import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Observable, Subscriber} from 'rxjs';
import {DictionaryObject} from '../../../../../common/api';
import {TranslateManager} from '../../../../../common/translate';
import {
    ClientErrorResponse,
    getClientErrorCodeByServerCode,
    getClientErrorResponseFromJson,
    getClientErrorTypeByStatus
} from '../../../core/http';
import {UploadProgressInfo} from './entity';

const UPLOAD_URL = '/api/client/file_import/provide';
const ATTACHMENT_TYPE_URL = '/api/client/dictionary/attachment-type';

export enum AttachmentType {
    PASSPORT = 'PASSPORT',
    SELFIE = 'SELFIE',
    ADDRESS = 'ADDRESS',
    DOCUMENT = 'DOCUMENT',
    BUSINESS_ADDRESS = 'BUSINESS_ADDRESS',
    PROOF = 'PROOF',
    CORPORATE_STRUCTURE = 'CORPORATE_STRUCTURE'
}
export enum AttachmentTypeID {
    PASSPORT = 1,
    SELFIE = 2,
    ADDRESS = 3,
    DOCUMENT = 4,
    BUSINESS_ADDRESS = 5,
    PROOF = 6,
    CORPORATE_STRUCTURE = 7
}

@Injectable()
export class AttachmentService {

    constructor(private _http: Http,
                private _translate: TranslateManager) {
    }

    attach(file: File, attachmentType: AttachmentType, progressSubscriber: Subscriber<UploadProgressInfo>): Observable<any> {
        console.log('estamos llamando a attach');
        return Observable.create(observer => {
            let xhr: XMLHttpRequest = new XMLHttpRequest(),
                formData: FormData = new FormData();
            formData.append('file', file, file.name);

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        observer.next(JSON.parse(xhr.response));
                        observer.complete();
                    } else {
                        let clientErrorResponse: ClientErrorResponse = new ClientErrorResponse();
                        try {
                            clientErrorResponse = getClientErrorResponseFromJson(JSON.parse(xhr.response));
                        } catch (e) {
                            clientErrorResponse.status = 500;
                            clientErrorResponse.type = getClientErrorTypeByStatus(500);
                            clientErrorResponse.errorCode = getClientErrorCodeByServerCode('ERR001');
                            clientErrorResponse.errorMessage = this._translate.getValue('COMMON.ERROR.SYSTEM');
                        }
                        observer.error(clientErrorResponse);
                    }
                }
            };

            xhr.upload.onprogress = (event) => {
                progressSubscriber.next({
                    progressInPercent: Math.round(event.loaded / event.total * 100),
                    progressInBytes: event.loaded
                });
            };

            xhr.open('POST', `${UPLOAD_URL}?type=${attachmentType}`, true);
            xhr.send(formData);
        });
    }

    getAttachmentTypes(type: AttachmentType): Observable<Array<DictionaryObject>> {
        const URL = `${ATTACHMENT_TYPE_URL}/?type=${type}`;
        return this._http.get(URL)
            .map(response => response.json())
            .map(response => response.attachmentTypes);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/modules/+registration/api/upload.attachment.service.ts